import { useSelector } from "react-redux";
import { useMemo } from "react";

const useTabList = () => {
  // Access the user details from the Redux store
  const reduxUserDetails =
    useSelector((state) => state.login.accessDetails) || [];
  // const level = JSON.parse(localStorage.getItem("Level"));

  // If the Redux state is empty, check local storage
  const localStorageUserDetails = localStorage.getItem("userDetails");
  const userDetails =
    reduxUserDetails.length > 0
      ? reduxUserDetails
      : JSON.parse(localStorageUserDetails) || { AccessDetails: [] };

  // Check for module existence
  const moduleExistsDOM =
    userDetails.AccessDetails.some((module) => module.ModuleName === "DOM") ||
    false;
  const moduleExistsSNO =
    userDetails.AccessDetails.some((module) => module.ModuleName === "SNO") ||
    false;
  // Define the TabList with the always-included DO_DP module
  const filteredTabList = {
    SNO_DOM_RR: [
      {
        name: "SNO",
        label: "SNO",
        value: "SNO",
        index: 0,
        graphViewTabList: [
          { name: "COF", value: "COF", index: 0 },
          { name: "Cost per Case", value: "Cost per Case", index: 1 },
          { name: "Cost Reductions", value: "Cost Reduction", index: 2 },
          {
            name: "Outbound Utilization",
            value: "Outbound Utilization",
            index: 3,
          },
          { name: "Throughput", value: "Throughput", index: 4 },
        ],
      },
      {
        name: "DOM",
        value: "DOM",
        label: "Distributed Order Management",
        index: 0,
        graphViewTabList: [
          { name: "COF", value: "COF", index: 0 },
          {
            name: "Recommended Diverts",
            value: "Recommended Diverts",
            index: 1,
          },
        ],
      },
      {
        name: "RR",
        value: "RR",
        label: "Rapid Response to Force Majeure",
        index: 0,
        graphViewTabList: [
          { name: "Timeline", value: "Timeline", index: 0 },
          { name: "Order Recom", value: "Order Recom", index: 1 },
          { name: "Fine Reductions", value: "Fine Reductions", index: 2 },
          {
            name: "STO Recommendations",
            value: "STO Recommendations",
            index: 3,
          },
          { name: "Salvage Moves", value: "Salvage Moves", index: 4 },
        ],
      },
    ],
    FGS_POOS: [
      {
        name: "FG Salvage",
        label: "FG Salvage",
        value: "FGS",
        index: 0,
        graphViewTabList: [
          { name: "Inv.Salvage risk", value: "Inv.Salvage risk", index: 0 },
          { name: "Potential savings", value: "Potential savings", index: 1 },
          // { name: "Inv.On Hand", value: "Inv.On Hand DOH", index: 2 },
        ],
      },
      {
        name: "Potential Out Of Stock",
        label: "Potential Out Of Stock",
        value: "POOS",
        index: 0,
        graphViewTabList: [
          { name: "R POOS Risk", value: "R POOS Risk", index: 0 },
          { name: "R POOS Reason", value: "R POOS Reason", index: 1 },
          { name: "N POOS Risk", value: "N POOS Risk", index: 2 },
          { name: "N POOS Reason", value: "N POOS Reason", index: 3 },
          { name: "Recom vs Active", value: "Recom vs Active", index: 4 },
          { name: "Diagnostics", value: "Diagnostics", index: 5 },
          {
            name: "NPOOS RPOOS Overlap",
            value: "NPOOS RPOOS Overlap",
            index: 6,
          },
        ],
      },
    ],
    DO_DP: [
      {
        name: "Deployment Planning",
        label: "Deployment Planning",
        value: "DP",
        index: 0,
        graphViewTabList: [
          { name: "COF", value: "COF", index: 0 },
          { name: "Redeploy Cost", value: "Redeploy.Cost", index: 1 },
          { name: "Primary Payload", value: "Primary Payload", index: 2 },
          { name: "STO Moves reason", value: "STO Moves reason", index: 3 },
          { name: "Workload", value: "Workload", index: 4 },
          {
            name: "Capacity Utilization",
            value: "Capacity Utilization",
            index: 5,
          },
        ],
      },
      {
        name: "Deployment Optimization",
        label: "Deployment Optimization",
        value: "DO",
        index: 0,
        graphViewTabList: [
          { name: "STRs Required", value: "STRs Required", index: 0 },
          { name: "TLs This Month", value: "TLs This Month", index: 1 },
          { name: "STRs To Cancel", value: "STRs To Cancel", index: 2 },
          { name: "Past Due STOs", value: "Past Due STOs", index: 3 },
          { name: "SKU-STO Parameters", value: "SKU-STO Parameters", index: 4 },
        ],
      },
    ],
    Distribution_Planning: [
      {
        name: "Distribution_Planning",
        label: "Distribution Planning",
        value: "DIP",
        index: 0,
        graphViewTabList: [
          { name: "Inv. On Hand", value: "Inv. On Hand", index: 0 },
          { name: "Waste Risk", value: "Waste Risk", index: 1 },
          { name: "COF", value: "COF", index: 2 },
          { name: "LT Capacity Breach", value: "LT Capacity Breach", index: 3 },
          { name: "Dock Utilization", value: "Dock Utilization", index: 4 },
          { name: "Bias", value: "Bias", index: 5 },
        ],
      },
      {
        name: "Capacity Planning",
        label: "Capacity Planning",
        value: "CP",
        index: 0,
        graphViewTabList: [
          { name: "ST Utilization", value: "ST Utilization", index: 0 },
          { name: "ST Capacity Breach", value: "ST Capacity Breach", index: 1 },
          { name: "LT Utilization", value: "LT Utilization", index: 2 },
          { name: "LT Capacity Breach", value: "LT Capacity Breach", index: 3 },
          { name: "Bias", value: "Bias", index: 4 },
          { name: "Throughput", value: "Throughput", index: 5 },
        ],
      },
      {
        name: "Network Planning Simulation",
        label: "Network Planning Simulation",
        value: "NPS",
        index: 0,
        graphViewTabList: [
          { name: "Revenue", value: "Revenue", index: 0 },
          { name: "Cost", value: "Cost", index: 1 },
          {
            name: "Storage Utilization",
            value: "Storage Utilization",
            index: 2,
          },
          {
            name: "Inbound Utilization",
            value: "Inbound Utilization",
            index: 3,
          },
          {
            name: "Outbound Dock Utilization",
            value: "Outbound Dock Utilization",
            index: 4,
          },
          { name: "Stockouts", value: "Stockouts", index: 5 },
        ],
      },
    ],
    FF: [
      // {
      //   name: "FF",
      //   label: "Potential Freight Opportunity",
      //   value: "FF",
      //   index: 0,
      //   graphViewTabList: [
      //     { name: "Under Capacity", value: "Under Capacity", index: 0 },
      //     { name: "Over Capacity", value: "Over Capacity", index: 1 },
      //     {
      //       name: "Transport Spend by Lane",
      //       value: "Transport Spend by Lane",
      //       index: 2,
      //     },
      //   ],
      // },
      {
        name: "DETENTION",
        label: "Detention spend",
        value: "DETENTION",
        index: 1,
        graphViewTabList: [
          { name: "Incident Rate Trend", value: "IncidentRateTrend", index: 0 },
          {
            name: "Detention Spend Trend",
            value: "DetentionSpendTrend",
            index: 1,
          },
          // {
          //   name: "Detention Reasons Codes",
          //   value: "DetentionReasonsCodes",
          //   index: 2,
          // },
          {
            name: "Facility Type Location Share",
            value: "FacilityTypeLocationShare",
            index: 2,
          },
        ],
      },
      // {
      //   name: "TM",
      //   label: "Transportation Management",
      //   value: "TM",
      //   index: 2,
      //   graphViewTabList: [
      //     { name: "Total Freight Spend", value: "Total Freight Spend", index: 0 },
      //     { name: "$ per case", value: "$ per case", index: 1 },
      //     { name: "$ per mile", value: "$ per mile", index: 2 },
      //     { name: "Total Detention Cost", value: "Total Detention Cost", index: 3 },
      //   ],
      // },
    ],
    IF: [
      {
        name: "IF",
        label: "Integrated Fulfillment",
        value: "IF",
        index: 0,
        graphViewTabList: [
          { name: "COF", value: "COF", index: 0 },
          { name: "Cost Savings", value: "Cost Savings", index: 1 },
          { name: "Delivery Cost", value: "Delivery Cost", index: 2 },
          {
            name: "Long Term Capacity Breach",
            value: "LT Capacity Breach",
            index: 3,
          },
        ],
      },
    ],
    SLP: [
      {
        name: "Service Level Prediction",
        label: "Service Level Prediction",
        value: "SLP",
        index: 0,
        graphViewTabList: [
          {
            name: "Order-Line Fulfillment",
            value: "Order-Line Fulfillment",
            index: 0,
          },
          { name: "Revenue", value: "Revenue", index: 1 },
          { name: "Order Blocks", value: "Order Blocks", index: 2 },
          { name: "Stock Out Orders", value: "Stock Out Orders", index: 3 },
        ],
      },
      {
        name: "IOF-Prioritization",
        label: "IOF-Prioritization",
        value: "IOFPRIORITIZATION",
        index: 1,
        graphViewTabList: [
          { name: "Utilization", value: "Utilization", index: 0 },
          { name: "Prioritization", value: "Prioritization", index: 1 },
          // { name: "Prioritization-Implemented", value: "Prioritization Implemented", index: 2 },
          // { name: "Special Orders", value: "Special Orders", index: 3 },
        ],
      },
      {
        name: "IOFPB",
        label: "On-Time Delivery Guardian",
        value: "IOFPB",
        index: 2,
        graphViewTabList: [
          { name: "Reason Codes", value: "Reason Codes", index: 0 },
          {
            name: "Revision Before RDD",
            value: "Revision Before RDD",
            index: 1,
          },
          { name: "Days Order Change", value: "Days Order Change", index: 2 },
          { name: "Expected On-time", value: "Expected On-time", index: 3 },
        ],
      },

      // {
      //   name: "ERM",
      //   label: "Exception Reason Managment",
      //   value: "ERM",
      //   index: 3,
      //   graphViewTabList: [
      //     {
      //       name: "Reason Code-Quantity Cuts",
      //       value: "Reason Code-Quantity Cuts",
      //       index: 0,
      //     },
      //     {
      //       name: "Reason Code-Late Loads",
      //       value: "Reason Code-Late Loads",
      //       index: 1,
      //     },
      //     {
      //       name: "Exceptions-Sales Doc",
      //       value: "Exceptions-Sales Doc",
      //       index: 2,
      //     },
      //     {
      //       name: "Exception Monitoring",
      //       value: "Exception Monitoring",
      //       index: 3,
      //     },
      //   ],
      // },
    ],
  };

  // Memoize the TabList based on module existence
  return useMemo(
    () => ({
      SNO_DOM_RR: filteredTabList["SNO_DOM_RR"],
      DO_DP: filteredTabList["DO_DP"],
      FGS_POOS: filteredTabList["FGS_POOS"],
      Distribution_Planning: filteredTabList["Distribution_Planning"],
      FF: filteredTabList["FF"],
      IF: filteredTabList["IF"],
      SLP: filteredTabList["SLP"],
      IOF: filteredTabList["IOF"],
      ERM: filteredTabList["ERM"],
    }),
    [moduleExistsDOM, moduleExistsSNO, filteredTabList],
  );
};

export default useTabList;
